import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Configuration} from '../config/config';
import 'rxjs/add/operator/map';

@Injectable()
export class TendencyReportService {
  public jwtToken: string;
  constructor(private http:HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  generateTendencyReport(data){
    return this.http.post(Configuration.ServerWithApiUrl+'/tendencyReport',data)
      .map((res: any)=>res)
  }

  generateCommTendencyReport(data){
    return this.http.post(Configuration.ServerWithApiUrl+'/commTendencyReport',data)
      .map((res: any)=>res)
  }

}



// WEBPACK FOOTER //
// ./src/app/Services/tendencyReport.service.ts